/**
 * Chart.js v4 global registration.
 *
 * Chart.js v4 no longer auto-registers components — every scale/element/controller
 * must be explicitly registered before any chart renders.
 *
 * Importing this file from index.jsx ensures registration runs once at app boot,
 * so any component using `react-chartjs-2` (Line/Bar/Pie/Doughnut/Radar/PolarArea)
 * will find all scales already registered.
 */
import {
    Chart as ChartJS,
    ArcElement,
    BarController,
    BarElement,
    CategoryScale,
    Filler,
    Legend,
    LinearScale,
    LineController,
    LineElement,
    PointElement,
    RadialLinearScale,
    SubTitle,
    TimeScale,
    TimeSeriesScale,
    Title,
    Tooltip,
} from 'chart.js';

ChartJS.register(
    ArcElement,
    BarController,
    BarElement,
    CategoryScale,
    Filler,
    Legend,
    LinearScale,
    LineController,
    LineElement,
    PointElement,
    RadialLinearScale,
    SubTitle,
    TimeScale,
    TimeSeriesScale,
    Title,
    Tooltip,
);
